import { Component, Input, OnChanges, OnInit } from '@angular/core';

@Component({
  selector: 'app-skeleton-loader',
  templateUrl: './skeleton-loader.component.html',
  styleUrls: ['./skeleton-loader.component.scss']
})
export class SkeletonLoaderComponent implements OnChanges, OnInit {
  @Input() variant: string = 'cargo-list';
  @Input() rows: number = 4;

  public rowItems: number[] = [];
  public trackingStateItems: number[] = [1, 2, 3];
  public trackingReportItems: number[] = [1, 2];
  public actionItems: number[] = [1, 2, 3];
  public driverBasicRows: number[] = [1, 2, 3, 4];
  public driverGpsRows: number[] = [1, 2, 3];

  ngOnInit(): void {
    this.rowItems = this.createItems(this.rows);
  }

  ngOnChanges(): void {
    this.rowItems = this.createItems(this.rows);
  }

  private createItems(count: number): number[] {
    const normalizedCount = Math.max(1, Number(count) || 1);
    return new Array(normalizedCount).fill(0).map((_, index) => index);
  }
}
